import {ParentPay} from '~/modules/api/api.types';

const SOURCE_TAGS = {
  web: {label: 'Web', className: 'badge-primary'},
  app: {label: 'App', className: 'badge-secondary'},
  granted: {label: 'Granted', className: 'badge-ghost'},
};

interface EntitlementPurchaseTagsProps {
  entitlement: Pick<
    ParentPay.EntitlementDetail,
    'purchaseSource' | 'purchasedBy'
  >;
}

/**
 * Tags showing where an entitlement was purchased (web/app) and by whom
 */
export const EntitlementPurchaseTags = ({
  entitlement,
}: EntitlementPurchaseTagsProps) => {
  const {purchaseSource, purchasedBy} = entitlement;
  const sourceTag = purchaseSource ? SOURCE_TAGS[purchaseSource] : null;

  return (
    <>
      {sourceTag && (
        <span className={`badge badge-sm ${sourceTag.className}`}>
          {sourceTag.label}
        </span>
      )}
      {purchasedBy && (
        <span
          className={`badge badge-sm ${
            purchasedBy === 'parent' ? 'badge-info' : 'badge-warning'
          }`}>
          Purchased by {purchasedBy}
        </span>
      )}
    </>
  );
};
